/* Form progress bar */
const formProgressSelector = '.umbraco-forms-paging';

function getProgressCounts(paging) {
    const currentCount = paging.querySelector('.umbraco-forms-paging-count .umbraco-forms-paging-count-number:first-child');
    const totalCount = paging.querySelector('.umbraco-forms-paging-count .umbraco-forms-paging-count-number:last-child');

    const current = Number.parseInt(currentCount?.textContent ?? '', 10);
    const total = Number.parseInt(totalCount?.textContent ?? '', 10);

    if (Number.isNaN(current) || Number.isNaN(total) || total < 1) {
        return null;
    }

    return { current, total };
}

function ensureProgressMarkup(paging) {
    let progressTrack = paging.querySelector('.umbraco-forms-progress');
    let progressBar = paging.querySelector('.umbraco-forms-progress-bar');

    if (!progressTrack) {
        progressTrack = document.createElement('div');
        progressTrack.className = 'umbraco-forms-progress';
        let progressCaptions = paging.querySelector('.umbraco-forms-paging-captions');

        if (progressCaptions) {
            progressCaptions.insertAdjacentElement('afterend', progressTrack);
        } else {
            paging.prepend(progressTrack);
        }
    }

    if (!progressBar) {
        progressBar = document.createElement('span');
        progressBar.className = 'umbraco-forms-progress-bar';
        progressTrack.append(progressBar);
    }

    progressTrack.setAttribute('role', 'progressbar');

    return { progressTrack, progressBar };
}

function updateFormProgress(paging) {
    const counts = getProgressCounts(paging);

    if (!counts) {
        return;
    }

    const { current, total } = counts;
    const { progressTrack, progressBar } = ensureProgressMarkup(paging);
    const progressPercent = total > 1
        ? Math.min(100, (((current - 1) + 0.5) / (total - 1)) * 100)
        : 100;
    const safePercent = Math.max(0, Math.min(100, progressPercent));
    const labelText = `Step ${current} of ${total}`;

    progressTrack.setAttribute('aria-label', labelText);
    progressTrack.setAttribute('aria-valuemin', '1');
    progressTrack.setAttribute('aria-valuemax', String(total));
    progressTrack.setAttribute('aria-valuenow', String(current));
    progressTrack.setAttribute('aria-valuetext', labelText);
    progressBar.style.width = `${safePercent}%`;

    paging.dataset.progressEnhanced = 'true';
}

function initFormProgress(root = document) {
    root.querySelectorAll(formProgressSelector).forEach((paging) => {
        updateFormProgress(paging);
    });
}

initFormProgress();

const progressObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        if (!(mutation.target instanceof Element)) {
            return;
        }

        const paging = mutation.target.closest(formProgressSelector);

        if (paging) {
            updateFormProgress(paging);
            return;
        }

        mutation.addedNodes.forEach((node) => {
            if (!(node instanceof Element)) {
                return;
            }

            if (node.matches(formProgressSelector)) {
                updateFormProgress(node);
                return;
            }

            initFormProgress(node);
        });
    });
});

progressObserver.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
});
